'use strict';

var _defineProperty = require("/home/runner/work/neoswap-app-react/neoswap-app-react/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, '__esModule', {
  value: true
});

/** @category Errors */
class InvalidPublicKeyError extends Error {
  constructor(invalidPublicKey, reason) {
    reason = reason ? `. ${reason}` : '';
    super(`The provided public key is invalid: ${invalidPublicKey}${reason}`);
    _defineProperty(this, "name", 'InvalidPublicKeyError');
    this.invalidPublicKey = invalidPublicKey;
  }
}
exports.InvalidPublicKeyError = InvalidPublicKeyError;
//# sourceMappingURL=errors.cjs.map